import {Component, OnInit} from '@angular/core';
import {BaseClass} from '../../../shared/classes/base';
import {UserTab} from '../../../shared/components/users-tabs/user-tab.model';
import {UserSyncPreview, ImportUser} from '../../_interfaces/sync-preview';
import {UserStatusEnum} from '../../_interfaces/user-status';
import {UsersService} from '../../users.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastController} from '@ionic/angular';
import {TranslationService} from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-settings-sync-details',
    templateUrl: './sync-details.component.html',
    styleUrls: ['./sync-details.component.scss']
})
export class SettingsUsersSyncDetailsComponent extends BaseClass implements OnInit {

    public readonly pageSize: number = 100;
    public readonly displayedColumns: string[] = [
        'imageUrl', 'name', 'jobTitle', 'responsible', 'status'
    ];
    public readonly userStatus = {
        0: {status: 'Novo Usuário', color: 'var(--semi-primary-color)'},
        1: {status: 'Usuário Atualizado', color: 'var(--warn-color)'},
        2: {status: 'Usuário Bloqueado', color: 'var(--danger-color)'}
    };
    public tabs: Array<UserTab> = [
        new UserTab('ERROS DE IMPORTACAO', 'var(--danger-color)', UserStatusEnum.Errors),
        new UserTab('USUÁRIOS NOVOS', 'var(--semi-primary-color)', UserStatusEnum.New),
        new UserTab('USUÁRIOS ATUALIZADOS', 'var(--warn-color)', UserStatusEnum.Updated),
        new UserTab('USUÁRIOS BLOQUEADOS', 'var(--danger-color)', UserStatusEnum.Blocked)
    ];
    public selectedSyncProccess: UserSyncPreview;
    public selectedTabIndex: number = 0;
    public users: Array<ImportUser> = [];
    public searchValue: string = '';
    public notSearching: boolean = true;
    public createdAt: Date = JSON.parse(localStorage.getItem('SyncProcess')).createdAt;

    private _userSyncPreview: UserSyncPreview;
    private _page: Array<number> = [];
    private _importUsers: Array<Array<ImportUser>> = [[], [], [], []];
    private _importUsersPaged: Array<Array<Array<ImportUser>>> = [[], [], [], []];
    private _searchValue: string = '';

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _usersService: UsersService
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() {

        this.tabs.forEach((tab, index) => {
            this._page[index] = 0;
        })

        const syncId = this._activatedRoute.snapshot.paramMap.get('syncId');

        this._usersService.getPagedFilteredUsersSyncProcesses(
            this._page[this.selectedTabIndex], this.pageSize, parseInt(syncId, 10)
        ).subscribe((response) => {
            if (response.data.userSyncProcessItems && response.data.userSyncProcessItems.length > 0) {
                this._userSyncPreview = response.data.userSyncProcessItems[0];
                this.tabs[1].count = this._userSyncPreview.newUserCount;
                this.tabs[2].count = this._userSyncPreview.updatedUserCount;
                this.tabs[3].count = this._userSyncPreview.blockedUserCount;
                this.tabs[0].count = this._userSyncPreview.errorUserCount;

                this._importUsers[0] = this._userSyncPreview.importErrors;
                this._importUsers[1] = this._userSyncPreview.newUsers.users;
                this._importUsers[2] = this._userSyncPreview.updatedUsers.users;
                this._importUsers[3] = this._userSyncPreview.blockedUsers.users;
                this._importUsersPaged[0] = this.splitIntoSubArray(this._userSyncPreview.importErrors.concat());
                this._importUsersPaged[1] = this.splitIntoSubArray(this._userSyncPreview.newUsers.users.concat());
                this._importUsersPaged[2] = this.splitIntoSubArray(this._userSyncPreview.updatedUsers.users.concat());
                this._importUsersPaged[3] = this.splitIntoSubArray(this._userSyncPreview.blockedUsers.users.concat());
                this._loadSyncedUsers(UserStatusEnum.Active);
            }

        }, (error) => this.getErrorNotification(error));
    }

    private splitIntoSubArray(arr: Array<ImportUser>): Array<Array<ImportUser>> {
        const newArray: Array<Array<ImportUser>> = [];
        while (arr.length > 0) {
            newArray.push(arr.splice(0, this.pageSize));
        }
        return newArray;
    }

    public goToPage(page: number) {
        if (page !== this._page[this.selectedTabIndex]) {
            this._page[this.selectedTabIndex] = page;
            this.users = this._importUsersPaged[this.selectedTabIndex][this._page[this.selectedTabIndex] - 1];
        }
    }

    public selectTab(index: number) {
        this.selectedTabIndex = index;
        if (this._searchValue === '' || this._searchValue === null) {
            this._loadSyncedUsers(this.tabs[this.selectedTabIndex].status);
        } else {
            this.triggerSearch(this._searchValue);
        }
    }

    public triggerSearch(searchValue: string) {
        this._searchValue = searchValue;
        if (searchValue === '' || searchValue === null) {
            this.notSearching = true;
            this._loadSyncedUsers(this.tabs[this.selectedTabIndex].status);
        } else {
            this.notSearching = false;
            this.users = this._importUsers[this.selectedTabIndex].filter(
                x => x.name.toUpperCase().includes(searchValue.toUpperCase()));
        }
    }

    public goToProcesses(): void {
        this._router.navigate(['usuarios/processo-de-sincronia']);
    }

    private _loadSyncedUsers(status: UserStatusEnum): void {
        switch (status) {
            case UserStatusEnum.New:
                this.users = this._importUsersPaged[1][this._page[this.selectedTabIndex]];
                break;

            case UserStatusEnum.Updated:
                this.users = this._importUsersPaged[2][this._page[this.selectedTabIndex]];
                break;

            case UserStatusEnum.Blocked:
                this.users = this._importUsersPaged[3][this._page[this.selectedTabIndex]];
                break;

            default:
                this.users = this._importUsersPaged[0][this._page[this.selectedTabIndex]];
        }
    }
}
